
import type { RiskPlusReport } from "../entities/report/RiskPlusReport";
import { RiskPlusReportSchema } from "../entities/report/schemas/RiskPlusReport.schema";
import type { License } from "../entities/user/License";
import { getApiService } from "./api";
import { z } from "zod";

class RiskReportService {

  
  async getRiskReportById(id: string): Promise<RiskPlusReport> {

    const apiService = getApiService();

    try {
      const response = await apiService.getParsed(
        `/risk-plus-report/${id}`,
        { riskPlusReport: RiskPlusReportSchema }
      );

      if( response.status !== "success" || !response.riskPlusReport ) {
        throw new Error("Failed to fetch risk report");
      }

      return response.riskPlusReport;

    } catch (error) {
      console.error("Error fetching risk report:", error);
      throw error;
    }
  }

  async generateReports(id: string): Promise<{ jobId: string; license: Partial<License>}> {

    const apiService = getApiService();

    try {
      const response = await apiService.postParsed(
        `/risk-plus-report/create`,
        {
          useCaseChatId: id,
        },
        {
          jobId: z.string(),
          license: z.object({
            riskPlusReportCredits: z.number().optional().default(0)
          })
        }
      );
      
      if(response.status !== "success" || !response.jobId){
        throw new Error(`Failed to generate reports for use case with id ${id}: ${response.message || "Server error"}`);
      }

      return {
        jobId: response.jobId,
        license: response.license,
      }

    } catch (error) {
      console.error(
        `Error generating reports for use case with id ${id}:`,
        error,
      );
      throw error;
    }
  }

}

export const riskReportService = new RiskReportService();


let _riskReportService: RiskReportService | null = null; 

export function getRiskReportService(): RiskReportService {

    if (!_riskReportService) {
      _riskReportService = new RiskReportService();
    }
    return _riskReportService;
}


